import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import {
  AnonymousAvatarComponent as AnonymousAvatarIcon,
} from 'ui/Icons';
import { getCurrentUser } from 'store/modules/auth';
import { theme } from '../../../../tailwind.config';
import { IBankTransactionComment } from '../types';
import { formatDateWithoutOffset } from 'utils';
import { EUserType, IUser } from 'services/BackendApi';

const userTypeMapping = {
  [EUserType.TA]: 'Travel Agent',
  [EUserType.SR]: 'Sales Representative',
  [EUserType.FINANCE]: 'Finance',
  [EUserType.RL]: 'Rate Loader',
  [EUserType.ADMIN]: 'Admin',
};

interface IBankTransactionCommentsViewProps {
  comment: IBankTransactionComment;
  handleCommentToDelete: (commentUuid: string) => void;
}

export const BankTransactionCommentsView: React.FC<IBankTransactionCommentsViewProps> = ({ comment, handleCommentToDelete }) => {
  const author = [comment.createdBy.firstName, comment.createdBy.lastName]
    .filter(Boolean)
    .join(' ');
  const date = formatDateWithoutOffset(comment.createdAt, 'd MMM yyyy, HH:mm');
  const role = userTypeMapping[comment.createdBy.type];
  const loggedInUser = useSelector(getCurrentUser) as IUser;
  
  const isYou = comment.createdBy.uuid === loggedInUser.uuid;
  const canDelete = isYou;

  const handleDelete = useCallback(() => handleCommentToDelete(comment.uuid), [handleCommentToDelete, comment.uuid]);
  
  return (
    <div className="view-comment flex items-start gap-[10px]">
      <div className="user-picture">
        <AnonymousAvatarIcon icon={theme.colors['gray-100']} fill={theme.colors['gray-40']} />
      </div>
      <div className="comment-container">
        <p className="comment-title font-pt-sans text-gray-100 m-0 text-[12px]">
          {!isYou && <span className="comment-author font-bold capitalize">{author}</span>}
          {!isYou && <span className="author-role">&nbsp;({role})</span>}
          {isYou && <span className="comment-author font-bold capitalize">You</span>}
          ,&nbsp;<span className="comment-created-date">{date}</span>
          {canDelete && <span className="comment-edit text-brown-100 underline capitalize cursor-pointer ml-[5px]" onClick={handleDelete}>Delete</span>}
        </p>
        <div className='font-[Helvetica,Arial,sans-serif]' dangerouslySetInnerHTML={{ __html: comment.text }}/>
      </div>
    </div>
  )
};

